import { createRoute } from "@tanstack/react-router";
import { ExecSummary } from "@/components/marketing/exec-summary";
import { MonthlyLeads } from "@/components/marketing/monthly-leads";
import { PageHeader } from "@/components/shared/page-header";
import { Route as authenticatedRoute } from "../_authenticated";

function MarketingSummaryPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Marketing — Executive Summary"
        description="The most important marketing numbers across all three brands, for leadership."
      />
      <ExecSummary />
      <MonthlyLeads />
    </div>
  );
}

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/marketing/summary",
  component: MarketingSummaryPage,
});
